"use client";

import type { PrefetchedPermissions } from "@/lib/permission-checks";
import { createContext, useContext } from "react";

const PrefetchedPermissionsContext =
  createContext<PrefetchedPermissions | null>(null);

export const PrefetchedPermissionsProvider = ({
  permissions,
  children,
}: {
  permissions: PrefetchedPermissions;
  children: React.ReactNode;
}) => {
  return (
    <PrefetchedPermissionsContext.Provider value={permissions}>
      {children}
    </PrefetchedPermissionsContext.Provider>
  );
};

export const usePrefetchedPermissions = () => {
  return useContext(PrefetchedPermissionsContext);
};
